import React, {
	useMemo,
	Fragment,
	ComponentType,
	PropsWithChildren,
	ReactNode,
} from "react";

// 函数式组件通用memo
function UseMemo<T>({
	deps,
	children,
	wrap = Fragment,
}: {
	deps: any[];
	children: () => ReactNode;
	wrap?: ComponentType<PropsWithChildren>;
}) {
	const c = useMemo(children, deps);
	const Wrap = wrap;
	return <Wrap>{c}</Wrap>;
}

export default UseMemo;
